/* ============
 * shippingProvider Transformer
 * ============
 */

import Transformer from './transformer';

export default class ShippingProviderTransformer extends Transformer {

  static fetch(shippingProvider) {
    return {
      id: shippingProvider.id,
      name: shippingProvider.name,
      code: shippingProvider.code,
    };
  }

  static send(shippingProvider) {
    return {
      id: shippingProvider.id,
      name: shippingProvider.name,
      code: shippingProvider.code,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/shippingProvider.js